<div class="how-it-works-content text">
    <div class="description" [innerHTML]="description"></div>
</div>